export type { Centre } from './get-centre.query'
export type { CentreDetails } from './get-centre-details.query'

export { buildContactLinks, getCentreDetails } from './get-centre-details'
